import { createContext, useContext } from 'react';
const DEFAULT_DEACTIVATE_MODAL_CONTEXT_VALUE = {
  isDeactivateModalOpen: false,
  openDeactivateModal: () => {},
  closeDeactivateModal: () => {}
};
export const ProductDeactivateModalContext = /*#__PURE__*/createContext(DEFAULT_DEACTIVATE_MODAL_CONTEXT_VALUE);
export const useProductDeactivateModal = () => useContext(ProductDeactivateModalContext);